<template>
  <a-modal
    :visible.sync="TipDialogVisible"
    width="400px"
    class="member-limit-dialog-box "
    :footer="null"
    :mask-closable="false"
    @cancel="TipDialogVisible=false"
  >
    <div
      class="dialog-tip-box"
    >
      <i class="icon iconfont iconicon-test68 fail-icon" />
      <h2>{{ $t('message["1278"]') }}</h2>
      <div class="d-tip-con">
        <template v-if="typeError===104 ">
          {{ $t('message["1407"]') }}。
        </template>
        <template v-else>
          <template v-if="bindType==='mobile'">
            {{ failTelTip[0] }} {{ value }}  {{ failTelTip[1] }}。
          </template>
          <template v-else-if="bindType==='email'">
            {{ failEmailTip[0] }} {{ value }}   {{ failEmailTip[1] }}。
          </template>
          <template v-else-if="bindType==='user'">
            {{ failQwTip[0] }} {{ value }}  {{ failQwTip[1] }}。
          </template>
        </template>
      </div>
      <div class="limit-btn-box">
        <a-button
          type="primary"
          @click="TipDialogVisible=false"
        >
          {{ $t('message["1597"]') }}
        </a-button>
      </div>
    </div>
  </a-modal>
</template>
<script>
export default {
  props: {
    bindType: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    typeError: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      TipDialogVisible: false,
      submiting: false
    }
  },
  computed: {
    failQwTip () {
      return this.$t('message["1055"]').split('|')
    },
    failTelTip () {
      return this.$t('message["1059"]').split('|')
    },
    failEmailTip () {
      return this.$t('message["1065"]').split('|')
    }
  },
  mounted () {
  },
  methods: {
    changeLimitDialog (b) {
      this.TipDialogVisible = b
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-tip-box .icon-tixing {
  color: #f57676 !important;
}
</style>
